import styled from 'styled-components';

import MarketingFooter from 'src/components/ui/MarketingFooter';
import Button from 'src/components/ui/Button';
import ThemedLogo from 'src/components/ui/ThemedLogo';

const MobileMessageWrapper = styled.div`
    background: var(--surface);
    height: var(--viewport-height);
    overflow: hidden;
`;

const MobileMessageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    padding: 0 16px;
    width: 100%;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const MobileMessageLogo = styled(ThemedLogo)`
    width: 180px;
    margin-bottom: 16px;
`;

const MobileMessageTextWrapper = styled.div`
    font-size: 16px;
    font-weight: 700;
    text-align: center;
`;

const MobileMessageActionButton = styled(Button)`
    background: var(--poki-blue);
    border-color: var(--poki-blue);
    color: #fff;
`;

const MobileMessageCoinBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    background: url('/assets/coins-background.svg') no-repeat top left / cover;
    width: 100%;
    height: calc(100% - 150px);
`;

function MobileMessage() {
    const handleClick = () => {
        window.open('https://developers.poki.com', '_blank');
    };

    return (
        <MobileMessageWrapper>
            <MobileMessageCoinBackground />
            <MobileMessageContent>
                <MobileMessageLogo alt="Poki for Developers - Beta" />
                <MobileMessageTextWrapper>
                    <p>
                        Test, debug, and optimize your games for web with the Poki Inspector Tool.
                        Designed for desktop, head to Poki for Developers to get started!
                    </p>
                </MobileMessageTextWrapper>
                <MobileMessageTextWrapper>
                    <MobileMessageActionButton onClick={handleClick}>
                        Go to developers.poki.com
                    </MobileMessageActionButton>
                </MobileMessageTextWrapper>
            </MobileMessageContent>
            <MarketingFooter />
        </MobileMessageWrapper>
    );
}

export default MobileMessage;
